import { defineStore } from "pinia";

export type loginState = {
    user: string;
    email: string;
    brand: string;
    role: string;
    logoURL: string;
    error: string;
};

export const useLoginStore = defineStore({
    id: "login",
    state: (): loginState => ({
        user: "",
        email: "",
        brand: "audi",
        role: "admin",
        logoURL: "",
        error: "",
    }),
    actions: {
        /**
         * Asigna un tema tomando la marca que reciebe por props.
         * @param {string} brand - Marca del usuario; proviene del token de autenticación.
         * @return {null} Sin respuesta
         */
        defineTheme(brand: string): void {
            // localStorage.clear();
            if (brand === "vw" || brand === null) {
                this.brand = brand ?? "vw";
                localStorage.setItem("brand", brand ?? "vw");
                localStorage.setItem("idBrand", import.meta.env.VITE_BRAND_ID);
                document.body.classList.add(this.brand);
                import("@/styles/themes/vw.scss");
                return;
            }
            if (brand === "audi") {
                this.brand = brand;
                localStorage.setItem("brand", brand);
                localStorage.setItem("idBrand", import.meta.env.VITE_BRAND_ID);
                document.body.classList.add(this.brand);
                import("@/styles/themes/audi.scss");
                return;
            }
            if (brand === "seat") {
                this.brand = brand;
                localStorage.setItem("brand", brand);
                localStorage.setItem("idBrand", import.meta.env.VITE_BRAND_ID);
                document.body.classList.add(this.brand);
                import("@/styles/themes/seat.scss");
            }
            if (brand === "porsche" || brand === "PORSCHE") {
                this.brand = brand;
                localStorage.setItem("brand", "porsche");
                localStorage.setItem("idBrand", import.meta.env.VITE_BRAND_ID);
                document.body.classList.add(this.brand);
                import("@/styles/themes/porsche.scss");
                return;
            }
        },
    },
});
